// extracted by mini-css-extract-plugin
export var container = "Highlight-module--container--1CIu1";
export var textContainer = "Highlight-module--textContainer--fA_Xj";
export var almond = "Highlight-module--almond--tr6xY";
export var tan = "Highlight-module--tan--2FLV_";
export var reverse = "Highlight-module--reverse--1MlTM";